<template>
  <div id="main-container">
    <div id="login-container">
      <img
        src="~@/assets/images/lca_solutions_logo.png"
        alt="Logo Services Coop de France"
        class="logo-coop-de-france"
      />
    </div>
    <div id="logo-optiflux-over">
      <v-form v-model="valid" class="login-form" @submit.prevent="connexion">
        <v-container fluid>
          <v-layout>
            <v-flex class="loginInput" xs6>
              <v-text-field
                v-model="email"
                :autofocus="true"
                :rules="emailRules"
                label="E-mail"
                solo
              ></v-text-field>
            </v-flex>
            <v-flex class="loginInput" xs6>
              <v-text-field
                v-model="password"
                :rules="passwordRules"
                :type="'password'"
                label="Mot de passe"
                solo
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex class="d-flex justify-end">
              <v-btn class="loginButton" type="submit" :disabled="!valid">
                Se connecter
              </v-btn>
              <v-btn
                class="loginButton"
                @click.prevent="forgot"
                :disabled="!emailIsValid"
              >
                Mot de passe oublié ?
              </v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
    </div>
    <div class="link-know-more">
      <p>
        POUR EN SAVOIR PLUS, CLIQUEZ
        <a
          href="https://www.servicescoopdefrance.coop/performance-industrielle/exploitation-et-logistique/"
          target="_blank"
          >ICI</a
        >
      </p>
    </div>
    <div class="footer-mentions" v-if="showMentions">
      <v-icon aria-hidden="true" @click="closeMentions()" medium>close</v-icon>
      <p class="mentions-text">Application sécurisée - Solutions +</p>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import anime from 'animejs';
import router from '@/router';
import JQuery from 'jquery';
let $ = JQuery;

export default {
  data: () => ({
    showMentions: true,
    user: null,
    valid: false,
    password: null,
    passwordRules: [(v) => !!v || 'Le mot de passe est requis'],
    email: null,
    emailRules: [
      (v) => !!v || "L'email est requis",
      (v) =>
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
          v
        ) || "L'email doit être valide",
    ],
  }),
  computed: {
    emailIsValid() {
      return /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
        this.email
      );
    },
  },
  methods: {
    connexion() {
      if (!this.valid) return null;
      const url = process.env.VUE_APP_BASE_URL + process.env.VUE_APP_USER_INFOS;
      axios({
        method: 'get',
        url: url,
        headers: {
          user: this.email,
        },
      })
        .then((res) => {
          this.$store.dispatch('addUserInfos', res.data).then(() => {});
        })
        .finally(() => {
          this.connect();
        });
    },
    connect() {
      const url = process.env.VUE_APP_BASE_URL + process.env.VUE_APP_API_LOGIN;
      this.$store.dispatch('addUser', this.email);
      var self = this;
      axios({
        method: 'get',
        url: url,
        headers: {
          user: this.email,
          token: this.password,
        },
      })
        .then((response) => {
          self.$store.dispatch('addUserId', response.data.id);
          self.$store.dispatch('addUserNames', {
            firstName: response.data.firstName,
            lastName: response.data.lastName,
          });
          self.$store.dispatch('addUserCoop', response.data.cooperative);
          const userInfos = self.$store.state.userInfos;
          if (userInfos.pageAccueil === true) {
            router.push({ path: '/accueil' });
          } else if (userInfos.pageAvant === true) {
            router.push({ path: '/vision-globale' });
          } else if (userInfos.pageApres === true) {
            router.push({ path: '/optimisation' });
          } else {
            router.push({ path: '/accueil' });
          }
        })
        .catch((err) => {
          self.authError(err);
        });
    },
    authError() {
      this.$store.commit('setOnLoadToast', {
        message: 'Identification incorrecte !',
        type: 'error',
      });
      this.$toasted.show('Identification incorrecte !', { type: 'error' });
      this.password = null;
    },
    forgot() {
      const self = this;
      if (this.email) {
        axios({
          method: 'post',
          url:
            process.env.VUE_APP_BASE_URL +
            process.env.VUE_APP_SEND_FORMATTED_FORGOT_MAIL,
          data: {
            from: this.user,
            type: 'MDP_OUBLIE',
            to: this.email,
          },
        })
          .then(() => {
            self.$toasted.show(
              `Un email vous à été envoyé à l'adresse ${this.email}`,
              { type: 'success' }
            );
          })
          .catch((error) => {
            if (error.response.status === 400) {
              this.error = 'Mauvais identifiants';
            } else {
              this.error = 'Erreur de connexion au serveur';
            }
            self.$toasted.show(this.error, { type: 'error' });
            router.push('/');
          });
      } else {
        self.$toasted.show(
          "Vous devez d'abord renseigner un identifiant valide.",
          { type: 'error' }
        );
      }
    },
    closeMentions() {
      this.showMentions = false;
    },
  },
  created() {
    let state = this.$store.state;
    let newState = {};

    Object.keys(state).forEach((key) => {
      newState[key] = null;
    });
    Object.assign(state, newState);
  },
  mounted() {
    const onLoadToast = this.$store.getters.onLoadToast;
    if (onLoadToast !== null) {
      this.$toasted.show(onLoadToast.message, { type: onLoadToast.type });
    }
    anime
      .timeline({ loop: false })
      .add({
        targets: '.ml14 .line',
        scaleX: [0, 1],
        opacity: [0.5, 1],
        easing: 'easeInOutExpo',
        duration: 1500,
      })
      .add({
        targets: '.ml14 .letter',
        opacity: [0, 1],
        translateX: [40, 0],
        translateZ: 0,
        scaleX: [0.3, 1],
        easing: 'easeOutExpo',
        duration: 500,
        offset: '-=400',
        delay: function (el, i) {
          return 150 + 25 * i;
        },
      });
  },
};
</script>

<style lang="scss" scoped>
.v-text-field {
  display: inline;
}

#login-container {
  z-index: 2;
}

.login-form {
  width: 550px;
  transform: scale(0.8);
  margin: 0px 10px 0 auto;
}

@media only screen and (min-width: 650px) and (max-width: 1000px) {
  .login-form {
    width: 75%;
    transform: scale(1);
    margin: 140px auto 0;
  }
}

@media only screen and (max-width: 650px) {
  .login-form {
    width: 100%;
    transform: scale(1);
    margin: 140px auto 0;
  }
}

#main-container {
  position: relative;
  height: 100vh;
  width: 100vw;
  background-image: url('~@/assets/images/optiflux_background.jpg');
  background-size: contain;
  background-position: center;
}

@media only screen and (max-height: 500px) {
  #main-container {
    z-index: 3;
    position: relative;
    height: 100vh;
    width: 100vw;
    background-image: none;
  }
}

@media only screen and (min-width: 650px) and (max-width: 1000px) and (min-height: 740px) {
  #main-container {
    position: relative;
    height: 100vh;
    width: 100vw;
    background-image: url('~@/assets/images/optiflux_background.jpg');
    background-size: 120%;
    background-position: bottom 95px center;
  }
}

@media only screen and (min-width: 650px) and (max-width: 1000px) and (max-height: 740px) {
  #main-container {
    z-index: 3;
    position: relative;
    height: 100vh;
    width: 100vw;
    background-image: none;
  }
}

@media only screen and (min-width: 650px) and (max-width: 1000px) and (min-height: 740px) {
  #main-container {
    position: relative;
    height: 100vh;
    width: 100vw;
    background-image: url('~@/assets/images/optiflux_background.jpg');
    background-size: 120%;
    background-position: bottom 95px center;
  }
}

@media only screen and (max-width: 650px) and (max-height: 570px) {
  #main-container {
    z-index: 3;
    position: relative;
    height: 100vh;
    width: 100vw;
    background-image: none;
  }
}

@media only screen and (max-width: 650px) and (min-height: 570px) {
  #main-container {
    position: relative;
    height: 100vh;
    width: 100vw;
    background-image: url('~@/assets/images/optiflux_background.jpg');
    background-size: contain;
    background-position: bottom 95px center;
  }
}

#logo-optiflux-over {
  position: relative;
  overflow: hidden;
  height: 100%;
  z-index: 1;
  background-image: url('~@/assets/images/optiflux_logo.png');
  background-size: 28%;
  background-position: center left 2%;
}

@media only screen and (max-height: 500px) {
  #logo-optiflux-over {
    background-image: none;
  }
}

@media only screen and (min-width: 650px) and (max-width: 1000px) and (max-height: 740px) {
  #logo-optiflux-over {
    background-image: none;
  }
}

@media only screen and (min-width: 650px) and (max-width: 1000px) and (min-height: 740px) {
  #logo-optiflux-over {
    position: relative;
    overflow: hidden;
    height: 100%;
    z-index: 1;
    background-image: url('~@/assets/images/optiflux_logo.png');
    background-size: 33%;
    background-position: bottom 200px left 2%;
  }
}

@media only screen and (max-width: 650px) and (max-height: 570px) {
  #logo-optiflux-over {
    background-image: none;
  }
}

@media only screen and (max-width: 650px) and (min-height: 570px) {
  #logo-optiflux-over {
    position: relative;
    overflow: hidden;
    height: 100%;
    z-index: 1;
    background-image: url('~@/assets/images/optiflux_logo.png');
    background-size: 28%;
    background-position: bottom 131px left 2%;
  }
}

.link-know-more {
  position: absolute;
  color: rgb(65, 65, 65);
  bottom: 0px;
  height: 90px;
  padding: 0% 0% 0% 1%;
  z-index: 3;
  letter-spacing: 0.02rem;
  font-size: 1.1rem;
  width: 100vw;
  display: flex;
}

@media only screen and (max-height: 380px) {
  .link-know-more {
    display: none;
  }
}

.v-messages__message {
  color: white;
  font-size: 1rem;
  background-color: #f8a331;
  padding: 3px 5px;
  width: fit-content;
}
.error--text {
  color: white !important;
  caret-color: white !important;
}
.footer-mentions {
  position: absolute;
  color: rgb(65, 65, 65);
  bottom: 0;
  height: 48px;
  left: 0px;
  z-index: 4;
  letter-spacing: 0.02rem;
  font-size: 1.1rem;
  background-color: white;
  width: 100vw;
  display: flex;
}

.footer-mentions .v-icon {
  color: #ff9400;
  line-height: 48px;
  padding: 0 10px;
}

.footer-mentions .mentions-text {
  line-height: 48px;
}

.logo-coop-de-france {
  left: 30px;
  height: 120px;
  z-index: 3;
  position: absolute;
  display: flex;
  margin-top: 8px;
}

.flex {
  padding-bottom: 0px !important;
  padding-top: 0px !important;
}

.btns-login-form {
  margin-left: auto;
}

</style>
